import { render, staticRenderFns } from "./SelectMassUnit.vue?vue&type=template&id=3425280a&scoped=true&"
import script from "./SelectMassUnit.vue?vue&type=script&lang=js&"
export * from "./SelectMassUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3425280a",
  null
  
)

export default component.exports